module.exports = __webpack_public_path__ + "static/media/upload_projects.bffcc353.svg";